<template>
    <nav class="navbar" aria-label="product configurator navigation">
        <a href="/" class="logo" aria-label="link to homepage">
            <img :src="isLandingPage ? '/assets/images/icons/logo-white.svg' : '/assets/images/icons/logo-primary.svg'" alt="thredd logo" />
        </a>
        <a href="/" class="homeBtn" aria-label="link to homepage">
            Back to home
        </a>
    </nav>
</template>

<script lang="ts">
    export default {
        props: {
            isLandingPage: Boolean,
        }
    };
</script>